import { Download } from "lucide-react";
import { Button } from "@/core/components/ui/button";
import { Card } from "@/core/components/ui/card";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { PayrollRunStatusBadge } from "@/payroll/pay-periods/payroll-run-status-badge";
import { RelativeTime } from "@/payroll/pay-periods/relative-time";
import type { IPayrollRun } from "@/payroll/payroll.d";

interface LegacyScriptOutputStateProps {
  run: IPayrollRun;
  onDownload: () => void;
}

export const LegacyScriptOutputState = ({
  run,
  onDownload,
}: LegacyScriptOutputStateProps) => (
  <Stack
    fullWidth
    justify="center"
    align="center"
    className="min-h-[300px]"
    gap="md"
  >
    <Typography variant="titleW3">
      Payroll is available for this period.
    </Typography>
    <Card className="w-full max-w-4xl overflow-hidden">
      <Stack className="p-4" fullWidth>
        <Stack
          direction="row"
          align="center"
          justify="between"
          gap="sm"
          fullWidth
          className="flex-wrap"
        >
          <Stack direction="row" align="center" gap="sm">
            <PayrollRunStatusBadge status={run.status} />
            <Stack gap="none" className="min-w-0">
              <Typography variant="bodyW2" className="break-words">
                Requested by {run.user_display_name || "Volca Admin"}
              </Typography>
              <RelativeTime
                timestamp={run.created_at}
                className="text-tertiary-text"
              />
            </Stack>
          </Stack>
          <Button
            variant="default"
            size="sm"
            onClick={onDownload}
            leftIcon={<Download className="h-4 w-4" />}
          >
            Download
          </Button>
        </Stack>
      </Stack>
    </Card>
  </Stack>
);
